<header class="header-wrapper">
  <a [routerLink]="['/terms']" class="header-wrapper__serasa-logo">
    <img
      ngSrc="./assets/logo-serasa-experian-white.svg"
      alt="Logotipo Serasa Experian"
      NgOptimizedImage
      height="96"
      width="184"
      />
  </a>

  <h1 class="header-wrapper__application-title">Menu de produtos</h1>

  <seds-header-user
    class="header-wrapper__user-profile"
    [userData]="userData"
    colorMode="default-dark"
    (actionButtonMenuClick)="onButtonItemClick($event)">
  </seds-header-user>
</header>

<ca-sub-menu-items [ApplicationLinks]="applicationLinks"></ca-sub-menu-items>

<section class="terms-wrapper">
  <h1 class="terms-wrapper__title">Termos de uso de privacidade</h1>
  @if (!hasError) {
    @if (!success) {
      <h3 class="terms-wrapper__subtitle">
        Para continuar acessando o Menu de Produtos, por favor, leia e aceite os
        termos abaixo:
      </h3>
    }
    @if (!success) {
      <div #pendingTerms>
        @if (showRequiredTerm || showAlertError) {
          <ca-alert
            class="terms-wrapper__alert"
            [icon]="'error'"
            [title]="alertErrorTitle"
            [message]="alertErrorMessage"
            [type]="'error'"
          ></ca-alert>
        }
        @if (myTerms.length === 0) {
          <seds-loaders-spinner class="terms-wrapper__loading" [mode]="modeIndeterminate"></seds-loaders-spinner>
        }
        @if (myTerms.length > 0) {
          <section class="terms-wrapper__terms">
            <img
              ngSrc="./assets/images/icon-contract.svg"
              alt="Ícone de contrato"
              NgOptimizedImage
              height="96"
              width="96"
              />
              <ul class="terms-wrapper__terms__items">
                @for (term of myTerms; track term) {
                  <li
                    class="terms-wrapper__terms__items__item"
                    [attr.required]="term.termVersion.acceptanceRequired"
                    >
                  <div
                    class="terms-wrapper__terms__items__item--top"
              [ngClass]="{
                required:
                  !term?.checked &&
                  term?.termVersion?.acceptanceRequired &&
                  showRequiredTerm
              }"
                    >
                    <label>
                      <input
                        type="checkbox"
                        caCheckbox
                        (change)="setCheckedTerm(term.termId, $event)"
                        />
                      <span></span>
                    </label>
                    <p>
                      Declaro que li e aceito o
                      <a (click)="getTermsContent(term.termId)">
                        {{ term?.summary }}</a
                        >. {{ term?.description }}
                      </p>
                    </div>
                    @if (
                      !term?.checked &&
                      term?.termVersion?.acceptanceRequired &&
                      showRequiredTerm
                      ) {
                      <div
                        class="terms-wrapper__terms__items__item--bottom"
                        >
                        <mat-icon class="material-icons-round">warning</mat-icon>
                        <span>Termo obrigatório.</span>
                      </div>
                    }
                  </li>
                }
              </ul>
            </section>
          }
          <section class="terms-wrapper__footer" [hidden]="!myTerms.length">
            @if (!isNotMandatory) {
              <a
                (click)="setRememberLater()"
                class="link-remember launch-event"
                appAnalyticsButton
                launchSection="TermosDeUsoPrivacidade"
                launchLabel="Lembrar mais tarde"
                launch-event
                href=""
                >Lembrar mais tarde</a
                >
              }
              <button
                mat-button eds-button motif="primary"
                class="terms-wrapper__button"
                (click)="acceptTerms()"
                appAnalyticsButton
                launchSection="TermosDeUsoPrivacidade"
                launchLabel="Aceito"
                launch-event
                [disabled]="showRequiredTerm"
                >
                Aceito
              </button>
            </section>
          </div>
        } @else {
          <section class="terms-wrapper__success">
            <i
              class="terms-wrapper__success__img"
              [inlineSVG]="'/assets/images/success.svg'"
              [setSVGAttributes]="_attrsSuccess"
            ></i>
            <h1 class="terms-wrapper__success__title">Sucesso</h1>
            <h3 class="terms-wrapper__success__subtitle">
              {{ successSubtitle }} aceito(s) com sucesso!
            </h3>
            <mat-spinner diameter="48" class="spinner"></mat-spinner>
          </section>
        }
      } @else {
        <div class="terms-wrapper__unavailable">
          <i
            [inlineSVG]="'/assets/svg/unavailable.svg'"
            [setSVGAttributes]="_attrs"
          ></i>
          <h4 class="terms-wrapper__unavailable__title">
            Não foi possível exibir os Termos de uso e privacidade.
          </h4>
          <p class="terms-wrapper__unavailable__text">
            Estamos trabalhando para resolver esse problema. <br />
            Por favor, tente novamente mais tarde e, se o erro persistir, entre em
            contato com a nossa central de atendimento.
          </p>
        </div>
      }

      <ng-template #unavailable>
        <div class="terms-wrapper__unavailable">
          <i
            [inlineSVG]="'/assets/svg/unavailable.svg'"
            [setSVGAttributes]="_attrs"
          ></i>
          <h4 class="terms-wrapper__unavailable__title">
            Não foi possível exibir os Termos de uso e privacidade.
          </h4>
          <p class="terms-wrapper__unavailable__text">
            Estamos trabalhando para resolver esse problema. <br />
            Por favor, tente novamente mais tarde e, se o erro persistir, entre em
            contato com a nossa central de atendimento.
          </p>
        </div>
      </ng-template>

    </section>

    <ca-footer class="terms-footer">
      <p>
        ©currentYear Experian Information Solutions, Inc. Experian Marketing
        Services, all rights reserved
      </p>
      <p>
        Experian and the Experian marks used herein are service marks or registered
        trademarks of Experian Informations Solutions, Inc
      </p>
      <p>
        Other product and company names mentioned herein are the property of their
        respective owners.
      </p>
    </ca-footer>
